import * as React from 'react';
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

export const checkValueTypeGlobal = (value) => typeof value;

export const capitalizeFirstLetterGlobal = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const determineTypeGlobal = (data) => {
  if (Array.isArray(data)) {
    return 'array';
  }
  if (typeof data === 'object' && data !== null) {
    return 'object';
  }
  return 'unknown';
};

export default function DatePickerGlobal({ value = null, dateList = [], onSelectDate }) {
  const dateValue = value ? new Date(Number(value)) : null;
  const availableDates = dateList.map((dateObject) => dayjs(dateObject.epoch).toDate());

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={['day']}
        disableToolbar
        format={'MMM DD, YYYY, HH:mm'}
        value={dayjs(dateValue)}
        onChange={(date) => onSelectDate(date, availableDates)}
        renderInput={(params) => <TextField size="small" fullWidth {...params} />}
        sx={{
          overflow: 'hidden',
          '& input': {
            fontSize: 12,
            marginTop: 0,
            paddingTop: 1,
            paddingBottom: 1,
            minWidth: 0,
          },
          '& .css-ysycdn-MuiInputBase-root-MuiOutlinedInput-root ': {
            minWidth: 0,
            width: 180,

            // padding: 10,
          },
          '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
            minWidth: 0,
          },
        }}
        shouldDisableDate={(day) => !availableDates.some((date) => dayjs(day).isSame(date, 'day'))}
      />
    </LocalizationProvider>
  );
}

DatePickerGlobal.propTypes = {
  value: PropTypes.string,
  dateList: PropTypes.array,
  onSelectDate: PropTypes.func,
};

export function formatEpochToDateString(epoch) {
  // Convert epoch to Date object
  const date = new Date(epoch);

  // Format the date to "MMM DD, YYYY, HH:mm"
  const formattedDate = date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });

  return formattedDate;
}
